<template>
  <div>
    <b-overlay
      variant="white"
      :show="submitting"
      spinner-variant="primary"
      blur="0"
      opacity=".75"
      rounded="sm"
    >
      <validation-observer ref="PricePackageDetailForm">
        <b-form ref="PricePackageDetailFormElement" class="" @submit.prevent="submit">
          <b-row>
            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="name">{{ t('Title') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider #default="{ errors }" :name="t('Title')" rules="required">
                  <b-form-input
                    id="title"
                    v-model="values.title"
                    name="title"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Title')"
                    tabindex="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>

            <b-col sm="6" lg="4">
              <b-form-group>
                <div class="d-flex form-group-label">
                  <label for="description">{{ t('Description') }}</label>
                  <span class="text-danger">*</span>
                </div>
                <validation-provider
                  #default="{ errors }"
                  :name="t('Description')"
                  rules="required"
                >
                  <b-form-input
                    id="description"
                    v-model="values.description"
                    name="description"
                    :state="errors.length > 0 ? false : null"
                    :placeholder="t('Description')"
                    tabindex="3"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6" lg="4">
              <b-form-group label-for="status" :label="t('Status')">
                <b-form-select
                  v-model="values.status"
                  name="status"
                  :options="packageStatusTypeOptions"
                  tabindex="10"
                >
                  {{ values.status ? t('Active') : t('Passive') }}
                </b-form-select>
              </b-form-group>
            </b-col>
            <b-col sm="6" lg="4" class="mt-2">
              <b-form-checkbox v-model="values.isDefault" name="check-button" switch tabindex="10">
                {{ values.isDefault ? t('Default') : t('Non-Default') }}
              </b-form-checkbox>
            </b-col>
          </b-row>
          <b-button
            variant="primary"
            class="mt-1 d-flex align-items-center"
            type="submit"
            tabindex="11"
          >
            {{ submitting ? t('Please Wait') : type === 'new' ? t('Create') : t('Edit') }}
          </b-button>
        </b-form>
      </validation-observer>
    </b-overlay>
  </div>
</template>
<script>
import {
  BCol,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BFormSelect,
  BFormCheckbox,
  BButton,
  BOverlay
} from 'bootstrap-vue';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { useUtils as useI18nUtils } from '@core/libs/i18n';
import { helper } from '@core/mixins/helper.js';

export default {
  components: {
    BOverlay,
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BForm,
    BFormSelect,
    BFormCheckbox,

    ValidationObserver,
    ValidationProvider
  },

  mixins: [helper],

  props: {
    type: {
      type: String,
      default: 'new'
    },
    submitting: {
      type: Boolean,
      default: false
    },
    values: {
      type: Object,
      default() {
        return {
          title: '',
          description: '',
          isDefault: false
        };
      }
    }
  },
  data() {
    return {
      statusOptions: [],
      packageStatus: []
    };
  },

  computed: {
    packageStatusTypeOptions() {
      const options = [{ text: this.$t('Make a Choice'), value: '' }];
      if (this.packageStatus && this.packageStatus.length > 0) {
        options.push(
          ...this.packageStatus.map(item => ({
            text: item.info,
            value: item.value
          }))
        );
      }
      return options;
    }
  },

  mounted() {
    this.statusOptions = [
      { value: 0, text: this.$t('Passive') },
      { value: 1, text: this.$t('Active') }
    ];
  },

  async created() {
    this.packageStatus = await this.getPackageStatus();
  },
  methods: {
    submit() {
      this.$refs.PricePackageDetailForm.validate().then(success => {
        if (success) {
          this.$emit('submit', {
            ...this.values
          });
        }
      });
    },
    resetForm() {
      this.$refs.PricePackageDetailFormElement.reset();
    }
  },

  setup() {
    const { t } = useI18nUtils();

    return {
      t
    };
  }
};
</script>
